export class CellSize {
    private readonly width: number;
    private readonly height: number;

    constructor(width: number, height: number) {
        if (width < 0) {
            throw new Error('width must be positive number');
        }
        if (height < 0) {
            throw new Error('height must be positive number');
        }

        this.width = width;
        this.height = height;
    }

    get Width() {
        return this.width;
    }

    get Height() {
        return this.height;
    }

    withWidth(width: number) {
        return new CellSize(width, this.height);
    }

    withHeight(height: number) {
        return new CellSize(this.width, height);
    }

    static fromJSON(cell_size: CellSize) {
        return new CellSize(cell_size.width, cell_size.height);
    }

}
